"use strict";

exports.__esModule = true;
exports.AlertsDataItemSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../../Core");
var _Device = require("../../../Device");
var _utils = require("../AlertsConditionConfiguration/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AlertsDataItemSelector = exports.AlertsDataItemSelector = function AlertsDataItemSelector(props) {
  var allDevices = (0, _react.useContext)(_Device.AllDeviceListContext);
  var devices = props.devices,
    onSelect = props.onSelect,
    selected = props.selected;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var selectedDevices = devices.map(function (device) {
    return allDevices.find(function (_device) {
      return _device.uuid === device;
    });
  });
  var dataItems = (0, _utils.getCommonSampleDataItems)(selectedDevices);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dataItems.length === 0 ? /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "AlertsDataItemSelector.noDataInfo",
    style: {
      position: "relative",
      top: "5px",
      whiteSpace: "nowrap"
    }
  }, translate("AlertsDataItemSelector.noItems.info", "No common data items for with SAMPLE category selected devices")) : /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, {
    placeholder: translate("AlertsDataItemSelector.placeholder.multiple", "Select Data Items"),
    dataTestId: "AlertsDataItemSelector.selector",
    selected: selected,
    style: {
      maxWidth: "250px"
    },
    items: dataItems,
    renderItemText: function renderItemText(item) {
      return item == null ? void 0 : item.name;
    },
    getKey: function getKey(item) {
      return item == null ? void 0 : item.name;
    },
    onSelect: onSelect,
    allPlaceholder: translate("AlertsDataItemSelector.placeholder.all", "All"),
    shouldSelectAllFiltered: true
  }));
};